import { PageHero } from "../components/common/PageHero";
import { FinalCta } from "../components/common/FinalCta";
import { Reveal } from "../components/motion/Reveal";
import { NEDEN_BIZ } from "../data/nedenBiz";



const NedenBiz = () => (
  <>
    <PageHero
      title="Neden Biz?"
      subtitle="17 Yıllık Deneyim, Güvenli ve Konforlu Öğrenci Yaşamı"
      desc="Samsun'da 17 yıllık deneyimli kadromuzla üniversite öğrencilerine güvenli, düzenli ve konforlu bir yaşam alanı sunuyoruz. Öğrencilerimizin yalnızca konaklama değil, kendilerini güvende ve rahat hissedebilecekleri bir ortamda yaşamalarını önemsiyoruz."
    />
    <section data-testid="neden-biz" className="section-y">
      <div className="container-x">
        <div className="grid gap-px overflow-hidden border border-line bg-line sm:grid-cols-2 lg:grid-cols-4">
          {NEDEN_BIZ.map((v, i) => (
            <Reveal key={v.title} delay={Math.min(i * 0.06, 0.3)} className="h-full">
              <div className="group flex h-full flex-col bg-cream-50 p-7 transition-colors duration-300 hover:bg-ink-900 sm:p-8" data-testid={`neden-item-${i}`}>
                <span className="text-xs font-bold tracking-[0.2em] text-ink-400 transition-colors duration-300 group-hover:text-cream-50/50">{String(i + 1).padStart(2, "0")}</span>
                <h2 className="mt-5 text-lg font-bold tracking-tight text-ink-900 transition-colors duration-300 group-hover:text-cream-50">{v.title}</h2>
                <p className="mt-3 text-sm leading-relaxed text-ink-500 transition-colors duration-300 group-hover:text-cream-50/60">{v.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
    <FinalCta />
  </>
);

export default NedenBiz;
